<template>
  <div class="wrapper__content-sale-document col-container">
    <div class="col-header">
      <div class="col-header-left">
        <ButtonCirclePlusComponent
          v-if="$canOpen('sales.invoices.add')"
          @onClick="invoiceAdd"
        />
        <span class="col-title">Facturas</span>
      </div>
      <div class="col-actions">
        <DownloadLote doc-type="invoice" />
        <ButtonFilterComponent
          @onChangeFilters="onChangeFilters"
          @onApplyFilters="onApplyFilters"
          @onResetFilters="onResetFilters"
          :setFilters="searchFilters"
          :loading="loading"
          :setStatus="filterStatus"
          placeholder="Buscar por número documento"
          isStatus
          isSearch
          isOrderBy
          isDates
          isClients
        >
          <template slot="customs">
            <!-- Establecimiento / punto de emisión -->
            <div class="df-section-custom">
              <p class="df-custom-label">Establecimiento</p>
              <el-select
                v-model="filterEstablishmentId"
                placeholder="Todos los establecimientos"
                clearable
                class="w-100"
                @change="onChangeEstablishment"
              >
                <el-option
                  v-for="est in establishments"
                  :key="est.id"
                  :label="establishmentLabel(est)"
                  :value="est.id"
                />
              </el-select>
            </div>

            <div class="df-section-custom">
              <p class="df-custom-label">Punto de emisión</p>
              <el-select
                v-model="filterEmissionPointId"
                :placeholder="
                  filterEstablishmentId
                    ? 'Todos los puntos'
                    : 'Selecciona un establecimiento'
                "
                :disabled="!filterEstablishmentId"
                clearable
                class="w-100"
                @change="onChangeEmissionPoint"
              >
                <el-option
                  v-for="ep in emissionPointsForSelected"
                  :key="ep.id"
                  :label="emissionPointLabel(ep)"
                  :value="ep.id"
                />
              </el-select>
            </div>

            <p class="pb-2 m-0 mt-2 font-bold text-color-blank">Buscar por</p>

            <el-radio-group
              v-model="filterIsPaid"
              @change="onChangeFilterLocal"
            >
              <el-radio class="d-block mb-1" label="1">Pagada</el-radio>
              <el-radio class="d-block mb-1" label="0">No pagada</el-radio>
            </el-radio-group>
          </template>
        </ButtonFilterComponent>
      </div>
    </div>
    <template>
      <WrapperScrollbarComponent @scrollingEnd="infiniteHandler">
        <InvoiceCardComponent
          v-for="(invoice, index) in filterInvoices"
          :key="invoice.id || index"
          :invoice="invoice"
          @onInvoiceUpdate="onInvoiceUpdate"
          @onInvoiceDeleted="onInvoiceDeleted"
        />
        <infinite-loading
          @distance="90"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <SkeletonOneCardComponent />
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <InvoiceEmptyComponent v-if="!invoices.length" />
          </div>
        </infinite-loading>
      </WrapperScrollbarComponent>
    </template>
  </div>
</template>

<script>
import ButtonCirclePlusComponent from "../../../components/ButtonCirclePlus";
import ButtonFilterComponent from "../../../components/DrawerFilter";
import InvoiceEmptyComponent from "./Empty";
import InvoiceCardComponent from "./InvoiceCard";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";
import WrapperScrollbarComponent from "../../../../components/WrapperScrollbar";
import DownloadLote from "@/modules/dashboard/sales/components/DownloadLote";

import invoiceService from "../services/invoiceService";
import tradeService from "@/modules/dashboard/profile/services/tradeService";

export default {
  name: "InvoiceColumnsComponent",
  data() {
    return {
      loading: true,
      searchFilters: {},
      filterIsPaid: null,
      establishments: [],
      filterEstablishmentId: null,
      filterEmissionPointId: null,
      filterStatus: [
        {
          label: "Borrador",
          key: "draft"
        },
        {
          label: "Aprobada",
          key: "success"
        },
        {
          label: "Anulada",
          key: "nuled"
        },
        {
          label: "Fallida",
          key: "failed"
        }
      ],
      page: 1,
      invoices: [],
      breakScroll: false,
      debounceTimer: null,
      customRangedates: null
    };
  },
  watch: {
    notication(newVal, oldVal) {
      if (oldVal === undefined) return;
      if (!newVal) return;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.onAsyncDataForDates();
      }, 200);
    }
  },
  computed: {
    notication() {
      return this.$store.getters.getNotification;
    },
    filterOrderBy() {
      const { orderBy } = this.searchFilters;
      return orderBy;
    },
    requestFilters() {
      const { search, from, to, status, clientId: client } = this.searchFilters;
      // Only include defined/non-null values to prevent API confusion
      const filters = {};
      if (search) filters.search = search;
      if (from) filters.from = from;
      if (to) filters.to = to;
      if (status) filters.status = status;
      if (client) filters.client = client;
      if (this.filterEstablishmentId)
        filters.establishment_id = this.filterEstablishmentId;
      if (this.filterEmissionPointId)
        filters.emission_point_id = this.filterEmissionPointId;
      return filters;
    },
    emissionPointsForSelected() {
      const est = this.establishments.find(
        e => e.id === this.filterEstablishmentId
      );
      return est ? est.emision_points || [] : [];
    },
    filterInvoices() {
      return this.invoices.concat().sort((a, b) => {
        if (this.filterOrderBy && this.filterOrderBy === "desc") {
          return a.total > b.total ? -1 : 1;
        } else if (this.filterOrderBy && this.filterOrderBy === "asc") {
          return a.total < b.total ? -1 : 1;
        }
        // Default: sort by date descending (most recent first)
        const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
        const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
        return dateB - dateA;
      });
    },
    getInvoicesFilters() {
      const { documents } = this.$store.getters.getModule("sales");
      return documents.invoices.filters.get;
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    invoiceAdd() {
      this.goRouter("sales.invoices.add");
    },
    onChangeFilterLocal() {
      this.updatedSearchFilters({
        is_paid: this.filterIsPaid
      });
    },
    async loadEstablishments() {
      try {
        const { data } = await tradeService.getStablishments();
        this.establishments = data?.data || data || [];
      } catch (e) {
        this.establishments = [];
      }
    },
    establishmentLabel(est) {
      const code = String(est.code || "").padStart(3, "0");
      return `${code} — ${est.name || est.address || "Establecimiento"}`;
    },
    emissionPointLabel(ep) {
      const code = String(ep.code || "").padStart(3, "0");
      return ep.description ? `${code} — ${ep.description}` : `Punto ${code}`;
    },
    onChangeEstablishment() {
      // Al cambiar de establecimiento, limpiar el punto de emisión seleccionado
      this.filterEmissionPointId = null;
      this.updatedSearchFilters({
        establishment_id: this.filterEstablishmentId,
        emission_point_id: null
      });
    },
    onChangeEmissionPoint() {
      this.updatedSearchFilters({
        emission_point_id: this.filterEmissionPointId
      });
    },
    updatedSearchFilters(filters) {
      this.searchFilters = {
        ...this.searchFilters,
        ...filters
      };

      this.$store.dispatch("salesDocumentsFiltersGet", {
        documentKey: "invoices",
        filters: this.searchFilters
      });
    },
    onChangeFilters(filters) {
      this.updatedSearchFilters(filters);
    },
    onApplyFilters() {
      this.onAsyncDataForDates();
    },
    onResetFilters() {
      this.filterIsPaid = null;
      this.filterEstablishmentId = null;
      this.filterEmissionPointId = null;

      this.updatedSearchFilters({
        is_paid: null,
        establishment_id: null,
        emission_point_id: null
      });
    },
    onAsyncDataForDates() {
      this.invoices = [];
      this.page = 1;
      // El aviso de refresco llega con debounce: el componente puede haberse
      // desmontado (navegación) antes de que corra.
      if (!this.$refs.infiniteLoading) return;
      this.$refs.infiniteLoading.stateChanger.reset();
      this.$store.dispatch("sendNotification", false);
    },
    onInvoiceUpdate({ id, data }) {
      const index = this.invoices.findIndex(inv => inv.id === id);
      if (index !== -1) {
        this.$set(this.invoices, index, data);
      }
    },
    onInvoicePaymentUpdated({ invoiceId, summary }) {
      // Actualización parcial del card tras registrar un pago (sin recargar la lista)
      const index = this.invoices.findIndex(inv => inv.id === invoiceId);
      if (index === -1) return;

      const current = this.invoices[index];
      const status =
        summary && summary.payment_status ? summary.payment_status : null;
      const balance = summary ? summary.balance : current.balance;

      const patched = {
        ...current,
        ...(summary
          ? {
              total_paid: summary.total_paid,
              total_retention: summary.total_retention,
              net_expected: summary.net_expected,
              balance: balance,
              payment_status: status
            }
          : {}),
        // is_paid se marca en backend cuando balance <= 0; reflejarlo en el card
        is_paid:
          status === "paid" || (balance !== undefined && balance <= 0)
            ? true
            : current.is_paid
      };

      this.$set(this.invoices, index, patched);
    },
    onInvoiceDeleted(id) {
      this.invoices = this.invoices.filter(inv => inv.id !== id);
    },

    async getInvoices($state) {
      try {
        this.loading = true;
        let response = await invoiceService
          .getInvoices({
            params: {
              ...{
                page: this.page,
                client: this.getClientId,
                is_paid: this.filterIsPaid
              },
              ...this.requestFilters,
              ...(this.filterEstablishmentId
                ? { establishment_id: this.filterEstablishmentId }
                : {}),
              ...(this.filterEmissionPointId
                ? { emission_point_id: this.filterEmissionPointId }
                : {})
            }
          })
          .finally(() => {
            this.breakScroll = false;
            this.loading = false;
          });
        const { data } = response.data || {};
        // El interceptor de Api.js "silencia" los GET cancelados por deduplicación
        // devolviendo { data: {} }. Sin este guard, data.length revienta, el catch
        // se lo traga y $state nunca se resuelve: el infinite-loading queda colgado
        // y la columna solo vuelve a cargar recargando la página entera.
        if (!Array.isArray(data)) {
          $state.loaded();
          return;
        }

        if (data.length) {
          if (this.page === 1) {
            this.invoices = data;
          } else {
            // Deduplicate: only push items not already in the list
            const existingIds = new Set(this.invoices.map(i => i.id));
            const newItems = data.filter(item => !existingIds.has(item.id));
            if (newItems.length === 0) {
              // All returned items are already shown — no more unique data
              $state.complete();
              return;
            }
            newItems.forEach(item => this.invoices.push(item));
          }
          this.page = this.page + 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        return false;
      }
    },
    infiniteHandler($state) {
      if (!$state || typeof $state.complete !== "function") return;
      if (this.breakScroll) return false;
      this.breakScroll = true;
      this.getInvoices($state);
    },
    setInitFilters() {
      // All filters
      this.searchFilters = this.getInvoicesFilters;

      // Local filters
      this.filterIsPaid = this.getInvoicesFilters?.is_paid;
      this.filterEstablishmentId =
        this.getInvoicesFilters?.establishment_id || null;
      this.filterEmissionPointId =
        this.getInvoicesFilters?.emission_point_id || null;
    }
  },
  components: {
    ButtonCirclePlusComponent,
    ButtonFilterComponent,
    InvoiceEmptyComponent,
    InvoiceCardComponent,
    SkeletonOneCardComponent,
    WrapperScrollbarComponent,
    DownloadLote
  },
  props: {
    getClientId: {
      default: null
    }
  },
  mounted() {
    this.setInitFilters();
    this.loadEstablishments();
    this.$root.$on("invoice-reminder-updated", this.onInvoiceUpdate);
    this.$root.$on("invoice-payment-updated", this.onInvoicePaymentUpdated);
  },
  beforeDestroy() {
    this.$root.$off("invoice-reminder-updated", this.onInvoiceUpdate);
    this.$root.$off("invoice-payment-updated", this.onInvoicePaymentUpdated);
  }
};
</script>

<style lang="scss" scoped>
.df-section-custom {
  margin-bottom: 12px;
}
.df-custom-label {
  font-size: 11px;
  font-weight: 600;
  color: #a0a4b0;
  margin: 8px 0 6px;
  letter-spacing: 0.2px;
}
.w-100 {
  width: 100%;
}
</style>
